const hasSymbol = typeof Symbol === 'function' && Symbol.for;
export default hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';


//////////////////
// WEBPACK FOOTER
// ../@mui/private-theming/ThemeProvider/nested.js
// module id = 760
// module chunks = 22